import { typeSafeAssign } from '@/utils/common'
import { DTO } from '../DTO'
import { computed, makeObservable, observable } from 'mobx'

export class B2gContract extends DTO {
  academyId: res.B2gContract['academyId'] | null = null
  schoolName: res.B2gContract['schoolName'] | null = null
  status: res.B2gContract['status'] | null = null
  amount: res.B2gContract['amount'] = 0
  contractStartDateTime: res.B2gContract['contractStartDateTime'] = null
  contractEndDateTime: res.B2gContract['contractEndDateTime'] = null
  subscribePlan: res.B2gContract['subscribePlan'] | null = null
  studentCount: res.B2gContract['studentCount'] = 0
  pdfUrl: res.B2gContract['pdfUrl'] = null

  constructor(data?: res.B2gContract) {
    super()
    makeObservable(this, {
      academyId: observable,
      status: observable,
      amount: observable,
      schoolName: observable,
      contractStartDateTime: observable,
      contractEndDateTime: observable,
      subscribePlan: observable,
      studentCount: observable,
      pdfUrl: observable,
      isUnSigned: computed,
    })

    if (data) typeSafeAssign(this, data)
  }
  get isUnSigned() {
    return this.status !== 'SIGNED'
  }
}
